<template lang="pug">
  div.event-info
    div.event-information
      div.information
        img.avatar(:src="event.imgUrl" @error="defaultImg")
        div.title
          p.name {{event.eventName}}
          p.desc {{event.introduction}}
      button.star(:class="{active: event.hasCollect}" @click.prevent.stop="collect(id, !event.hasCollect)" :title="`${event.hasCollect ? '取消收藏' : '收藏'}`" v-if="isLogged")
        i.fa.fa-star
    div.event-tag
      div.tag
        label 涉事品牌：
        span {{event.priBrand}}
      div.tag(v-if="event.secBrands")
        label 涉及品牌：
        span {{event.secBrands}}
      div.tag
        label 危机类型：
        span {{event.crisisTags}}
      div.tag(v-if="event.firstPlatform")
        label 首发平台：
        span {{event.firstPlatform}}
      div.tag(v-if="event.firstAccount")
        label 首发账号：
        span {{event.firstAccount}}
</template>

<script>
export default {
  name: 'EventInfo',
  data () {
    return {
      id: +this.$route.params.id
    }
  },
  props: {
    event: {
      type: Object,
      required: true
    },
    collect: {
      type: Function,
      required: true
    }
  },
  computed: {
    isLogged () {
      return this.$store.getters.logged
    }
  },
  methods: {
    defaultImg (e) {
      e.target.src = require('@index/assets/img/event_default.png')
    }
  }
}
</script>

<style lang="scss" scoped>
  .event-info{
    height: 184px;
    background-color: #ffffff;
    border-radius: 4px;
    margin-bottom: 20px;
    .event-information{
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 128px;
      .information{
        display: flex;
        align-items: center;
        margin-right: 100px;
        .title{
          p{
            margin: 8px 0;
          }
          p.name{}
          p.desc{
            font-size: 12px;
            color: #999;
          }
        }
        .avatar{
          min-width: 80px;
          width: 80px;
          height: 80px;
          border-radius: 50%;
          border: 1px solid #dcdcdc;
          margin-left: 24px;
          margin-right: 30px;
        }
        .title{

        }
      }
      button{
        min-width: 26px;
        height: 26px;
        border-radius: 4px;
        border: solid 1px #e8ebf1;
        background: #fff;
        margin-right: 24px;
        i{
          color: #999;
        }
        &.star{
          &.active{
            border: solid 1px #3989cb;
            background: #3989cb;
            .fa-star{
              color: #fff;
            }
          }
        }
      }
    }
    .event-tag{
      height: 54px;
      margin: 0 24px;
      border-top: 1px solid #eee;
      display: flex;
      align-items: center;
      .tag{
        font-size: 12px;
        padding: 0 24px;
        border-right: 1px solid #ddd;
        &:first-child{
          padding: 0 24px 0 6px;
        }
        &:last-child{
          border-right: none;
        }
        label{
          color: #666;
        }
        span{
          color: #333;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/index/EventCenter/EventInfo.vue